import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  const categoryColors = {
    "Tés": "bg-forest/10 text-forest",
    "Cafés": "bg-terracotta/10 text-terracotta",
    "Suplementos": "bg-amber-100 text-amber-700",
    "Cuidado Personal": "bg-rose-50 text-rose-600",
  };

  const badgeClass = categoryColors[product.category] || "bg-forest/10 text-forest";

  return (
    <Link
      to={`/producto/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="bg-white rounded-[2rem] p-5 border border-[#E5E0D8] transition-all duration-500 hover:-translate-y-2 shadow-[0_8px_30px_rgb(42,74,60,0.04)] hover:shadow-[0_20px_40px_rgb(42,74,60,0.08)] group overflow-hidden flex flex-col h-full opacity-0 animate-fade-in-up"
      style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'forwards' }}
    >
      <div className="relative aspect-[4/3] rounded-2xl overflow-hidden mb-4 bg-sand">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover product-card-img"
          loading="lazy"
        />
        <span className={`absolute top-3 left-3 px-3 py-1 rounded-full text-[11px] font-body font-semibold tracking-wide ${badgeClass}`}>
          {product.category}
        </span>
      </div>

      <div className="flex-1 flex flex-col">
        <h3 className="font-heading text-lg font-semibold text-forest mb-1.5 leading-snug">
          {product.name}
        </h3>
        <p className="font-body text-sm text-sage leading-relaxed mb-4 flex-1 line-clamp-2">
          {product.short_description || product.description}
        </p>
        <div className="flex items-center justify-between">
          <span className="font-body text-sm font-semibold text-terracotta">
            {product.price ? `$${product.price.toFixed(2)}` : product.price_text}
          </span>
          <span className="flex items-center gap-1 text-forest text-sm font-body font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Ver más <ArrowRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
}
